import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { logger } from '../utils/logger.util';


export interface PdfViewerOpenOptions {
  title: string;
  /** URL déjà résolue — prioritaire sur s3Key. */
  pdfUrl?: string;
  s3Key?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PdfViewerService {
  private readonly requestSubject = new BehaviorSubject<PdfViewerOpenOptions | null>(null);

  readonly request$ = this.requestSubject.asObservable();

  open(options: PdfViewerOpenOptions): void {
    if (!options.pdfUrl && !options.s3Key) {
      logger.warn('[PdfViewerService] open() requiert pdfUrl ou s3Key');
      return;
    }
    this.requestSubject.next(options);
  }

  close(): void {
    this.requestSubject.next(null);
  }
}
